<template>
  <!-- eslint-disable-next-line vue/require-component-is -->
  <div class="banner-preview t-banner-preview">
    <div class="banner-preview__body">
      <div class="banner-preview__image">
        <img
          v-if="imageUrl != null"
          :src="imageUrl"
          alt=""
          width="100%"
        >
      </div>
      <div class="banner-preview__content">
        <div class="banner-preview__title">{{ title }}</div>
        <div class="banner-preview__text">{{ text }}</div>
        <div
          v-if="primaryButtonText != null || secondaryButtonText != null"
          class="banner-preview__buttons"
        >
          <!-- eslint-disable-next-line vue/require-component-is -->
          <component
            v-if="primaryButtonText != null"
            v-bind="primaryButtonWrapperProps"
          >
            <button
              :slot="primaryButtonLinkInternal ? 'activator' : undefined"
              class="banner-preview__button banner-preview__button--primary"
            >{{ primaryButtonText }}</button>
            <span v-if="primaryButtonLinkInternal">Account link: {{ primaryButtonLink | optionName(internalLinkOptions) }}</span>
          </component>

          <!-- eslint-disable-next-line vue/require-component-is -->
          <component
            v-if="secondaryButtonText != null"
            v-bind="secondaryButtonWrapperProps"
          >
            <button
              :slot="secondaryButtonLinkInternal ? 'activator' : undefined"
              class="banner-preview__button banner-preview__button--secondary"
            >{{ secondaryButtonText }}</button>
            <span v-if="secondaryButtonLinkInternal">{{ secondaryButtonLink | optionName(internalLinkOptions) }}</span>
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { AppConfig } from '@/config/config'

  export default {
    name: 'BannerPreview',
    props: {
      imageName: {
        required: true,
        validator: function (value) {
          return value === null || typeof value === 'string'
        }
      },
      title: {
        required: true,
        validator: function (value) {
          return value === null || typeof value === 'string'
        }
      },
      text: {
        required: true,
        validator: function (value) {
          return value === null || typeof value === 'string'
        }
      },
      primaryButtonText: {
        type: String,
        default: undefined
      },
      primaryButtonLink: {
        type: String,
        default: undefined
      },
      primaryButtonLinkInternal: {
        type: Boolean,
        default: false
      },
      secondaryButtonText: {
        type: String,
        default: undefined
      },
      secondaryButtonLink: {
        type: String,
        default: undefined
      },
      secondaryButtonLinkInternal: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('internalLinks', ['internalLinkOptions']),
      imageUrl () {
        if (this.imageName != null) {
          return `${AppConfig.STORAGE_SERVICE_URL}/${this.imageName}`
        }
      },
      primaryButtonWrapperProps () {
        return this.primaryButtonLinkInternal ? this.tooltipProps : this.getButtonLinkProps(this.primaryButtonLink)
      },
      secondaryButtonWrapperProps () {
        return this.secondaryButtonLinkInternal ? this.tooltipProps : this.getButtonLinkProps(this.secondaryButtonLink)
      },
      tooltipProps () {
        return {
          is: 'v-tooltip',
          bottom: true
        }
      }
    },
    methods: {
      getButtonLinkProps (href) {
        return {
          href,
          is: 'a',
          target: '_blank',
          rel: 'noreferrer'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Roboto&display=swap');

  .banner-preview {
    width: 920px;
    min-height: 233px;
    background-color: #fff;
    font-family: "Open Sans", "Arial", "-apple-system", "system-ui", sans-serif;;
    padding-right: 40px;
    border-radius: 12px;
    box-shadow: 0 7px 40px rgba(45, 62, 80, .1);
    overflow-y: hidden;

    &__body {
      display: flex;
    }

    &__content {
      padding: 26px 0;
      flex-grow: 1;
      flex-shrink: 1;
    }

    &__title {
      font-size: 24px;
      font-weight: 700;
      color: #2d3e50;
      line-height: 33px;
      margin-bottom: 12px;
    }

    &__image {
      max-width: 290px;
      overflow: hidden;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      margin-right: 32px;

      > img {
        display: block;
      }
    }

    &__text {
      font-size: 16px;
      line-height: 28px;
    }

    &__buttons {
      display: flex;
      gap: 10px;
      margin-top: 32px;
    }

    &__button {
      user-select: none;
      height: 46px;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.499;
      white-space: nowrap;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      border: 2px solid transparent;
      border-radius: 28px;
      padding: 0 30px;

      &--primary {
        color: #fff;
        background-color: #c42036;
        box-shadow: 0 7px 40px rgba(196, 32, 54, .5);

        &:hover, &:focus {
          background-color: #de233c;
        }
      }

      &--secondary {
        border-color: #c42036;
        color: #c42036;
        box-shadow: none;

        &:hover, &:focus {
          color: #de233c;
          border-color: #de233c;
        }
      }
    }
  }
</style>
